export class TimeSpan {
    constructor(ticks) {
        this.ticks = ticks;
    }
    get totalDays() {
        const day = 86400000; // 24 * 60 * 60 * 1000
        const days = parseInt((this.ticks / day), 10);
        return days;
    }
    get totalHours() {
        const hour = 3600000; // 60 * 60 * 1000
        const days = parseInt((this.ticks / hour), 10);
        return days;
    }
    get totalMinutes() {
        const minute = 60000; // 60 * 1000
        const days = parseInt((this.ticks / minute), 10);
        return days;
    }
    get totalSeconds() {
        const second = 1000;
        const days = parseInt((this.ticks / second), 10);
        return days;
    }
    get totalMiliseconds() {
        return this.ticks;
    }
    get days() { return this.totalDays; }
    get hours() { return this.totalHours - (this.totalDays * 86400000); }
    get minutes() { return this.totalMinutes - (this.totalHours * 3600000); }
    get seconds() { return this.totalSeconds - (this.totalMinutes * 60000); }
    get miliSecunds() { return this.totalMiliseconds - (this.totalSeconds * 1000); }
    toString() {
        return `${this.days}d ${this.hours}h ${this.minutes}min ${this.seconds}s`;
    }
}
